import URL from 'url-parse';
import { LinkType, recognizeLinkTypeByUrl } from 'fym-common/src/utils/recognizeLinkTypeByUrl';
import { normalizeUrl } from 'fym-common/src/utils/normalizeUrl';

/**
 * Which platform a pasted address belongs to.
 *
 * The same recognition the rest of the product uses, so the icon beside a row
 * here is the icon the bio link will draw. An address we cannot parse is
 * `generic`, which is a real answer rather than an error.
 */
export function linkTypeForUrl(url: string): LinkType {
  try {
    return recognizeLinkTypeByUrl(new URL(normalizeUrl(url)));
  } catch {
    return LinkType.generic;
  }
}
